const regexpEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

export function esValorNoVacio (valor) {
  if (typeof str === 'string')
    return valor.trim() != "";
  else
    return valor != "";
}

export function esEmailValido (email) {
  return regexpEmail.test (email);
}